import type { NotificationChannel } from '@masters-club/types';
import type { BroadcastMedia } from '../types';

export const CHANNEL_OPTIONS: { id: NotificationChannel; label: string }[] = [
  { id: 'TELEGRAM', label: 'Telegram' },
  { id: 'EMAIL', label: 'Эл. почта' },
];

export const PARSE_MODE_OPTIONS = [
  { value: 'none', label: 'Без разметки' },
  { value: 'Markdown', label: 'Разметка Markdown (жирный, курсив, ссылки)' },
  { value: 'HTML', label: 'Разметка HTML' },
];

export const MEDIA_TYPES: { value: BroadcastMedia['type']; label: string }[] = [
  { value: 'photo', label: 'Фото' },
  { value: 'video', label: 'Видео' },
  { value: 'document', label: 'Документ' },
];

export const CHANNEL_DISPLAY_NAMES: Record<string, string> = {
  TELEGRAM: 'Telegram',
  APP: 'В приложении',
  EMAIL: 'Эл. почта',
};

export const MEDIA_TYPE_DISPLAY_NAMES: Record<string, string> = {
  photo: 'Фото',
  PHOTO: 'Фото',
  video: 'Видео',
  VIDEO: 'Видео',
  document: 'Документ',
  DOCUMENT: 'Документ',
};

export const PARSE_MODE_DISPLAY_NAMES: Record<string, string> = {
  Markdown: 'Разметка Markdown',
  HTML: 'Разметка HTML',
};
